import { SiteSettings } from '@core/shared';
import { ApiRuntime, OptionsApi, SESSION_QUERY_OPTIONS } from '@core/swagger-client';
import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext } from '@tanstack/react-router';

export const Route = createRootRouteWithContext<{
    queryClient: QueryClient;
    siteSettings: SiteSettings;
    runtime: ApiRuntime;
}>()({
    // The session resolves here, not in the loader: every beforeLoad finishes before any loader
    // starts, and the loaders then run in parallel. The QueryClient scopes every other key by this
    // session, so it has to be in the cache before a child loader hashes its first key.
    //
    // session, not refreshToken: this runs during SSR too and its result is dehydrated into the
    // page, so prefetching /refresh here put a real account token in that payload even after the
    // AuthProvider had stopped asking for one.
    //
    // Whatever a beforeLoad returns is serialised into the page as well (__beforeLoadContext), so
    // only the flag the loaders need goes out of here: never the session, the runtime or a token.
    beforeLoad: async ({ context }) => {
        const session = await context.queryClient.ensureQueryData(OptionsApi.login.session(SESSION_QUERY_OPTIONS));
        return { isAuthenticated: session.isAuthenticated };
    },
    loader: async ({ context }) => {
        const translations = await context.queryClient.ensureQueryData(
            OptionsApi.translation.get(context.siteSettings.defaultLanguage, {
                staleTime: 600_000
            })
        );
        return { translations };
    }
});
